import type { FunctionComponent } from 'react';
import * as styles from './LoadingSection.module.scss';

type LoadingSectionProps = {
  width?: number;
  height?: number | string;
};

const LoadingSection: FunctionComponent<LoadingSectionProps> = ({
  width = 50,
  height = 'inherit',
}) => <span className={styles.loadingSection} style={{ width, height }} />;

export default LoadingSection;
